import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qjab2vj5e: FaireProductEntity = {
  token: "p_2qjab2vj5e",
  type: "product",
  name: "60326PL - SATIN PRINT TUNIC DRESS",
  brandToken: "b_dlc3tm53ak",
  brandName: "Grade & Gather",
  imageUrl:
    "https://cdn.faire.com/fastly/e008bbc9db09b49949e0a3c08ecb847a9dc569c6bf0e93a0b4be7e5f5ad0d00f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be6cdd6cc67a788c305cc609f5c1bedfe928cb910f8d1d5d39cf03f226ecac9e.jpeg",
    "https://cdn.faire.com/fastly/17ee0d8c0a53adfbeb51f742a3cdbefd5ca4bc34b52631a7b5011a7f43d82bef.jpeg",
    "https://cdn.faire.com/fastly/fadd47508ca22bb5077b666d1f3010ac55d1468e3dc5f6a45e36a691dcac4242.jpeg",
    "https://cdn.faire.com/fastly/6f1dc5c692a3052ca6b30c7442bcc1afb5f2e005c0e9e7430e6d9c2fd37ee834.jpeg",
    "https://cdn.faire.com/fastly/7cbc6fd037fd4afc1f039afa74a7d715616b8472c94ac817d2bcf8fe1e263e09.jpeg",
    "https://cdn.faire.com/fastly/e4eb4b0df36b57fcad8d01f4b27a67bcd61563c8b9d154382ee666faeef6718a.jpeg",
    "https://cdn.faire.com/fastly/1ad8f8a90eb9eab7766cfff6cc5769266e9fdee95a349b4ae64dafcb9ee26bde.jpeg",
    "https://cdn.faire.com/fastly/ce2fdcf596c1dbdcfbbf9a1eec13a9ec2a0e22fd9b140e9e43e3fead4a487838.jpeg",
    "https://cdn.faire.com/fastly/96c1bfd7568b7e6083d88fe311f1c5b3215911abdf519b17245c7db12700137b.jpeg",
    "https://cdn.faire.com/fastly/b3423716ddd6c0766b85d20936b4e814b528d68064c8b5df92bff759dfb22467.jpeg",
    "https://cdn.faire.com/fastly/4e473068573412ec1efa3563a087de9066b1d4e61f8fad730e738c0fff769cc7.jpeg",
  ],
  priceDollars: 29.75,
  description:
    "Satin Print Tunic Dress\n\n• Sold in pack of 6\n• Sizes: 3S - 2M - 1L\n• 100% polyester\n• Imported",
  tags: [],
  msrpDollars: 59.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:43.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
